import { components, sizes } from '@/utils'

import { serviceNameViaPoint, urlShortenerSettingsDomainsStates } from '@/components/services/url-shortener-settings/domains/utils'
import tag from '@/components/tag'

export default function(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.state`),
        items: this.items,
        dense: true,
        disabled: this.disabled,
        required: this.required,
        clearable: !this.required,
        details: false
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            tag,
            {
              props: {
                label: item.title,
                color: urlShortenerSettingsDomainsStates[item.value].color,
                size: sizes.small
              }
            }
          )
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
